import normalize from "json-api-normalize";
import Attributes from "../../models/Attributes.js";
import Vue from 'vue';

export const UsersApi = {
  getCurrentUser() {
    return Vue.http.get("/api/customers/users").then(fulfilled => {
      return normalize(fulfilled.body).get(Attributes.userAttributes);
    })
  },

  deleteCustomer(params) {
    return Vue.http.patch("/api/customers/users/delete_user", params)
  },

  getGlobalInterests() {
    return Vue.http.get("/api/customers/user_interests").then(response => {
      return normalize(response.data).get(Attributes.userInterestAttributes);
    })
  },

  getInterestIds() {
    return Vue.http.get("/api/customers/user_interests/current").then(response => {
      return response.data
    })
  },

  saveInterestIds(ids) {
    return Vue.http.post("/api/customers/user_interests", {
      user_interest_ids: ids
    })
  },

  changeAvatar(file) {
    const formData = new FormData();
    formData.append("user[avatar]", file);

    return Vue.http.patch("/users", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(fulfilled => {
      return UsersApi.getCurrentUser()
    })
  },

  updateUser(params) {
    return Vue.http.patch("/users", {
      user: params
    })
  },

  register(params) {
    return Vue.http.post("/users", {
      user: params
    })
  },

  getBannedPasswordWords() {
    return Vue.http.get("/api/passwords/banned_words")
  },

  verifyPassword(password, email) {
    return Vue.http.post("/api/passwords/verify", {password, ...(email && {email})})
  }
}